export function Kpi({ label, value, accent }) {
  const ring = {
    emerald: "border-emerald-200 bg-emerald-50",
    amber: "border-amber-200 bg-amber-50",
    rose: "border-rose-200 bg-rose-50",
  }[accent] || "border-slate-200 bg-white";
  return (
    <div className={`rounded-xl border ${ring} p-3`} data-testid={`opp-kpi-${label}`}>
      <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold truncate">{label}</div>
      <div className="font-display text-xl font-bold text-slate-900 mt-0.5">{value}</div>
    </div>
  );
}
